import api from '@/apis/bu/bUVoucherListAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('bUVoucherList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'bu_voucher_list',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      paymentKey: 'is_treasury_approved', // key này dùng để lọc dữ liệu các bảng kê đã thanh toán để sinh hạch toán đồng thời
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Cập nhật trạng thái thanh toán hay chưa thanh toán
   * NXCHIEN 11.08.2022
   */
  updateApproved(context, res) {
    context.commit('updateApproved', res);
  },
  /**
   * Xóa dữ liệu ngoài danh sách
   * @param {*} context
   * @param {*} deleted
   */
  deleteItemMaster(context, deleted) {
    context.commit('deleteItems', deleted);
  },
};
const mutations = {
  ...crud.mutations,

  /**
   * Cập nhật trạng thái thanh toán hay chưa thanh toán
   * @param {*} state
   * @param {*} data
   * NXCHIEN 15.08.2022
   */
  updateApproved(state, data) {
    let paymentKey = state._config.field.paymentKey;
    let keyField = state._config.field.key;

    let id = data[keyField];
    for (let i = 0; i < state.items.length; i++) {
      let item = state.items[i];

      if (item[keyField] === id) {
        //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
        Object.assign(item, data);
        break;
      }
    }

    state.version++;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
